module.exports = __webpack_public_path__ + "static/img/loginBg.2ea3a7a3.png";